import { useEffect } from "react";
import Programmes from "../components/allProgrammes/programmes"
import AnimatedPage from "../components/animatedPage";
import Banner from "../components/banner/banner"
import ExploreProgrammes from "../sections/exploreProgrammes"
import { useSelector,useDispatch } from 'react-redux';
import { fetchAllProgrammesData } from "../redux/slice/allProgrammesPage";
import { retrunAssets } from "../utils/getAssets";



const AllProgrammes = () => {
    
    const dispatch = useDispatch()
    useEffect(()=>{
        dispatch(fetchAllProgrammesData("/all-programmes"))
    },[dispatch])

    const state = useSelector(state => state.allProgrammes)
    const allProgrammes = state?.data?.properties
    const text = allProgrammes?.pageTitle
    const bg = allProgrammes?.image != null ? retrunAssets(allProgrammes?.image[0]?.url) : ""
    const descriptionHeading = allProgrammes?.descriptionHeading
    const description = allProgrammes?.description
    const colleges = allProgrammes?.colleges?.items
     
    return (
        <AnimatedPage>
            {/* <ScrollToTop/> */}
            <Banner text={text} bg={bg} />
            <ExploreProgrammes descriptionHeading={descriptionHeading} description={description} />
            <Programmes colleges={colleges} />
        </AnimatedPage>
    )
}

export default AllProgrammes